/* global window */

import { useCallback, useEffect, useState } from 'react';

export default function usePageNav({ containerRef = null, pagesData = { limit: 0,
    count: 0,
    pages: 0 }, initialCurPage = 0, onUpdate = (newCurPage) => {}  }) {
    const [curPage, setCurPage] = useState(initialCurPage);
    useEffect(() => {
        setCurPage(initialCurPage);
    }, [initialCurPage]);
    /* Pagination */
    const curRange = Math.max((pagesData.limit * curPage), 1);
    const nextRange = Math.min((pagesData.limit * (curPage + 1)), pagesData.count);
    const generatedPagesData = (useCallback(() => {
        let pagesArr = [];
        const firstPage = 0;
        const lastPage = pagesData.pages;
        const MIN_OFFSET = -2;
        const MAX_OFFSET = 2;
        /* Create pages */
        for (let i = MIN_OFFSET; i <= MAX_OFFSET; i++) {
            const offset = (curPage + i);
            if (offset < firstPage || offset > lastPage) 
                continue;
            const displayPage = (offset + 1);
            pagesArr.push({ page: offset,
                displayPage });
        }
        /* Include first and last */
        if (!pagesArr.filter((p) => p.page === firstPage).length > 0) 
            pagesArr.unshift({ page: firstPage,
                displayPage: (firstPage + 1) });
        if (!pagesArr.filter((p) => p.page === lastPage).length > 0) 
            pagesArr.push({ page: lastPage,
                displayPage: (lastPage + 1) });
        return pagesArr;
    }, [pagesData.pages, curPage]))();
    const paginateUser = (page) => {
        if (page < 0 || page > pagesData.pages) 
            return;
        if (containerRef.current) {
            const rectTop = containerRef.current.getBoundingClientRect().top;
            window.scrollTo({
                top: Math.max(rectTop + window.pageYOffset - 250, 0),
            });
        }
        setCurPage(page);
        onUpdate(page);
    };
    /* End pagination */
    return {
        curPage,
        curRange,
        nextRange,
        generatedPagesData,
        paginateUser,
    };
}